<template>
  <transition-group tag="ul" :class="$style.list" name="list">
    <li
      :class="[$style.list__item]"
      :key="item.match.id"
      v-for="(item, index) in items"
    >
      <MatchSelectorItem
        :showPlanner="showPlanner"
        :match="item.match"
        @click="onClickSelectorItem(index)"
        :active="activeRoomId === item.match.roomId"
        :checkable="checkable"
        :checked="item.checked"
        @changeCheck="checked => onChangeCheckItem(index, checked)"
      />
    </li>
    <li
      v-if="isLoadingNextPage"
      :class="[
        $style.list__item,
        $style['list__item--loading'],
        $style.loading,
      ]"
      key="loadingNextPageIndicator"
    >
      <LoadingIndicator />
    </li>
  </transition-group>
</template>

<script setup lang="ts">
import MatchSelectorItem from './MatchSelectorItem.vue'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'

import type { MatchEntrance, MatchSelectorItem as ItemType } from '@/types/app'

const props = withDefaults(
  defineProps<{
    activeRoomId?: number
    items?: ItemType[]
    showPlanner?: boolean
    isLoadingNextPage?: boolean
    checkable: boolean
  }>(),
  {
    items: () => [],
    showPlanner: false,
    isLoadingNextPage: false,
  }
)

const emit = defineEmits<{
  (event: 'select', match: MatchEntrance): void
  (event: 'changeCheck', match: MatchEntrance, checked: boolean): void
}>()

const onClickSelectorItem = (index: number) => {
  emit('select', props.items[index].match)
}

const onChangeCheckItem = (index: number, checked: boolean) => {
  emit('changeCheck', props.items[index].match, checked)
}
</script>

<style lang="scss" module>
.list {
  &__item {
    transition:
      transform $transition-base,
      opacity $transition-base;

    &:nth-child(n + 2) {
      border-top: 1px solid $color-border-low-emphasis;
    }
  }
}

.loading {
  display: flex;
  height: 104px;
  align-items: center;
  justify-content: center;
}

// stylelint-disable selector-class-pattern
.list-enter,
.list-leave {
  opacity: 0;
  transform: translateX(16%);
}
// stylelint-enable selector-class-pattern
</style>
